@switch (name()) {
    @case ('asterisk') {
        <svg
            class="brand-icon__svg"
            viewBox="0 0 48 48"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <g stroke="currentColor" stroke-width="4" stroke-linecap="round">
                <line x1="24" y1="5" x2="24" y2="43" />
                <line x1="5" y1="24" x2="43" y2="24" />
                <line x1="10.6" y1="10.6" x2="37.4" y2="37.4" />
                <line x1="37.4" y1="10.6" x2="10.6" y2="37.4" />
            </g>
        </svg>
    }
    @case ('block') {
        <svg
            class="brand-icon__svg"
            viewBox="0 0 40 40"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
        >
            <rect x="9" y="2" width="22" height="10" rx="1" />
            <rect x="9" y="2" width="10" height="26" rx="1" />
        </svg>
    }
}
